(() => {
  function throttle (mainFunction, wait) {
    let timerFlag = null // Variable to keep track of the timer

    // Returning a throttled version
    return (...args) => {
      if (timerFlag === null) { // If there is no timer currently running
        mainFunction(...args) // Execute the main function
        timerFlag = setTimeout(() => { // Set a timer to clear the timerFlag after the specified delay
          timerFlag = null // Clear the timerFlag to allow the main function to be executed again
        }, wait)
      }
    }
  }

  const debounce = (callback, wait) => {
    let timeoutId = null
    return (...args) => {
      window.clearTimeout(timeoutId)
      timeoutId = window.setTimeout(() => {
        callback.apply(null, args)
      }, wait)
    }
  }


  let toggleAt = 0
  updateBreakpoint()
  setTimeout(updateBreakpoint, 1000)
  addEventListener('resize', throttle(updateBreakpoint, 200))
  addEventListener('resize', debounce(updateBreakpoint, 200))

  function updateBreakpoint () {
    const elemRect = document
      .querySelector('.AddToCartForm .product-description')
      .getBoundingClientRect()

    toggleAt = elemRect.top + window.scrollY
  }

  function update () {
    document.querySelectorAll('.f-sticky-atc-banner')
      .forEach(elem => {
        elem
          .classList
          .toggle('f--active', window.scrollY > toggleAt)
      })
  }

  update()
  setTimeout(update, 1000)
  document.addEventListener('scroll', throttle(update, 250), {passive: true})
  document.addEventListener('scroll', debounce(update, 250), {passive: true})

  document.body.addEventListener('click', (event) => {
    if (event.target.matches('.f-sticky-atc-banner.e--mobile .f-toggle, .f-sticky-atc-banner.e--mobile .f-toggle *')) {
      document.querySelector('.f-sticky-atc-banner.e--mobile').classList.add('f--expanded')
    }

    if (event.target.matches('.f-sticky-atc-banner.e--mobile [data-close], .f-sticky-atc-banner.e--mobile [data-close] *')) {
      document.querySelector('.f-sticky-atc-banner.e--mobile').classList.remove('f--expanded')
    }
  })
})()
